export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_24HRS_FORMAT = 'HH:mm';
export const TIME_12HRS_FORMAT = 'h:mm a';
